module.exports = __webpack_public_path__ + "Flag-140.d6b7432194530e1b92ab310d38f83300.svg";